// Open modals/drawers currently locking the page: only the first locks and only the last unlocks
let locks = 0;

/**
 * Locks the page scroll while a modal is open and returns the unlock function. It hides the
 * overflow of <html> instead of fixing the body, so the page stays where it was (no jump to the
 * top) and sticky elements like the sidebar don't move.
 */
export const stopScroll = () => {
  locks += 1;
  if (locks === 1) {
    document.documentElement.classList.add("hideScroll");
  }

  return () => {
    locks -= 1;
    if (locks === 0) {
      document.documentElement.classList.remove("hideScroll");
    }
  };
};
